export default "__VITE_ASSET__DsRtw0vS__"